import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

/**
 * Allows using React Router Link behavior on MUI components.
 *
 * Usage:
 * `<Button LinkComponent={LinkBehavior} href="/login">My Button</Button>`
 */
export const LinkBehavior = forwardRef<HTMLAnchorElement, { href: string }>(
  ({ href, ...props }, ref) => <Link ref={ref} to={href} {...props} />,
);

/**
 * Allows using React Router Link replace behavior on MUI components.
 *
 * Usage:
 * `<Button LinkComponent={LinkReplaceBehavior} href="/login">My Button</Button>`
 */
export const LinkReplaceBehavior = forwardRef<
  HTMLAnchorElement,
  { href: string }
>(({ href, ...props }, ref) => <Link ref={ref} to={href} replace {...props} />);
